export default "__VITE_ASSET__CqFOWYVv__"